import { Settings } from "@mui/icons-material";
import React from "react";
import { createContext } from "react";



export interface IZeroBaseFeeSettings {
    zeroEnabled: boolean,
    nonZeroEnabled: boolean,
    setEnabled: (zero: boolean, nonZero: boolean) => void
}



export const ZeroBaseFeeSettingsContext = createContext<IZeroBaseFeeSettings>(undefined);


type Props = {
    children: any,
}


export const ZeroBaseSettingsProvider = ({
    children,
}: Props) => {
    const [settings, setSettings] = React.useState<IZeroBaseFeeSettings>({
        zeroEnabled: true,
        nonZeroEnabled: false,
        setEnabled
    });

    function setEnabled(zero: boolean, nonZero: boolean) {
        setSettings({
            zeroEnabled: zero,
            nonZeroEnabled: nonZero,
            setEnabled
        })
    }

    return (
        <ZeroBaseFeeSettingsContext.Provider value={settings}>
            {children}
        </ZeroBaseFeeSettingsContext.Provider>
    );
};
